import { Component, Renderer2, ViewChild, OnInit, OnDestroy, Inject, PLATFORM_ID } from "@angular/core";
import { Router } from "@angular/router";
import { AppConfigSettings } from "./app.settings";
import { DataService, UserService } from "fg-library";
import { MatDrawer } from "@angular/material/sidenav";
import { TranslateService } from '@ngx-translate/core';
import { OverlayContainer } from "@angular/cdk/overlay";
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild("settingsDrawer") settingsDrawer!: MatDrawer;

  title = "fg-client";
  private dirObserver!: MutationObserver;
  private overlayObserver!: MutationObserver;

  constructor(
    private router: Router,
    private fgUserService: UserService,
    private renderer: Renderer2,
    private dataService: DataService,
    private translate: TranslateService,
    @Inject(OverlayContainer) private overlay: OverlayContainer,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    AppConfigSettings.setSettings();
  }

  openSettingsDrawer() {
    this.settingsDrawer.open();
  }

  ngOnInit() {
    this.getEnvProperties();
    this.getTranslation();

    if (isPlatformBrowser(this.platformId)) {
      this.applyDirToOverlays();

      // Observe <body dir> changes
      this.dirObserver = new MutationObserver(() => {
        this.applyDirToOverlays();
      });
      this.dirObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ["dir"],
      });

      // Observe overlay container changes
      this.overlayObserver = new MutationObserver(() => {
        this.applyDirToOverlays();
      });
      this.overlayObserver.observe(this.overlay.getContainerElement(), {
        childList: true,
        subtree: true,
      });
    }
  }

  private applyDirToOverlays() {
    if (!isPlatformBrowser(this.platformId)) return; 

    const dir = document.body.getAttribute("dir") || "ltr";
    const overlayEl = this.overlay.getContainerElement();

    overlayEl.setAttribute("dir", dir);

    overlayEl.querySelectorAll(".cdk-global-overlay-wrapper").forEach(w => w.setAttribute("dir", dir));
    overlayEl.querySelectorAll(".cdk-overlay-pane").forEach(panel => panel.setAttribute("dir", dir));

    const sidenav = document.querySelector('.global-sidenav-right, .global-sidenav-left');
    if (sidenav) {
      if (dir === 'rtl') {
        sidenav.classList.remove('global-sidenav-right');
        sidenav.classList.add('global-sidenav-left');
      } else {
        sidenav.classList.remove('global-sidenav-left');
        sidenav.classList.add('global-sidenav-right');
      }
    }

    overlayEl.querySelectorAll('.fgModalHeader, .fgModalBody, .fgModalFooter')
      .forEach(el => el.setAttribute('dir', dir));
  }

  ngOnDestroy(): void {
    if (this.dirObserver) this.dirObserver.disconnect();
    if (this.overlayObserver) this.overlayObserver.disconnect();
  }

  getEnvProperties() {
    this.dataService
      .getCustomServiceData("fgProperty/fg_deployed_app_id", "")
      .subscribe((response: any) => {
        this.fgUserService.localConfig.deploymentID = response.value;
      });

    this.dataService
      .getCustomServiceData("fgProperty/fg_secured_fields", "")
      .subscribe((response: any) => {
        this.fgUserService.localConfig.fgSecureFields = response.value;
      });
  }

  getTranslation(): any {
    this.dataService.getLocaleFile("en").subscribe((response: any) => {
      this.translate.setTranslation("en", response);
    });
  }
}
